import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "button", "spinner", "buttonText"]
  static values = {
    personId: Number,
    page: { type: Number, default: 1 },
    perPage: { type: Number, default: 5 },
    total: Number,
    type: String // observation type like "family", "career", etc.
  }

  async loadMore() {
    if (this.loading) return
    this.loading = true

    // Show loading state
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = "Loading..."

    try {
      const nextPage = this.pageValue + 1
      const observationType = this.typeValue || ""
      const url = `/people/${this.personIdValue}/observations?page=${nextPage}&per_page=${this.perPageValue}&observation_type=${encodeURIComponent(observationType)}`

      // Get CSRF token from meta tag
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const response = await fetch(url, {
        credentials: "same-origin", // Include cookies for authentication
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": csrfToken
        }
      })

      if (!response.ok) throw new Error("Failed to load more")

      const html = await response.text()
      
      // Parse the response to get just the items and metadata
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const items = doc.querySelector("[data-items]")
      const hasMore = doc.querySelector("[data-has-more]")?.dataset.hasMore === "true"

      if (items) {
        // Append new items to container
        this.containerTarget.insertAdjacentHTML("beforeend", items.innerHTML)
        this.pageValue = nextPage
      }

      // Calculate remaining after this page
      const remaining = this.totalValue - (nextPage * this.perPageValue)
      
      if (!hasMore || remaining <= 0) {
        // No more items - show "All loaded" message
        if (this.hasButtonTarget) {
          this.buttonTarget.disabled = true
          this.buttonTarget.classList.remove("hover:bg-white", "cursor-pointer")
          this.buttonTarget.classList.add("cursor-default", "opacity-60")
        }
        if (this.hasButtonTextTarget) {
          this.buttonTextTarget.textContent = "All observations loaded"
        }
      } else if (this.hasButtonTextTarget) {
        // Update button text with remaining count
        this.buttonTextTarget.textContent = `Load more (${remaining} more)`
      }
    } catch (error) {
      console.error("Error loading more observations:", error)
      // Show error state
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = "Error loading - click to retry"
      }
    } finally {
      this.loading = false
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    }
  }
}

